import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

const initialState = {
  repayMentDataDisb: {},
  paymentStatusData: {},
  paymentDetails: {},
  orderDetailsData: null,
  isLocationCaptured: false,
};

export const checkoutSlice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    updateRepaymentDataDisb: (state, action) => {
      state.repayMentDataDisb = action.payload;
    },
    updatePaymentStatusData: (state, action) => {
      console.log('action.payload', action.payload);
      state.paymentStatusData = action.payload;
    },
    updatePaymentDetails: (state, action) => {
      state.paymentDetails = action.payload;
    },
    updateOrderDetails: (state, action) => {
      state.orderDetailsData = action.payload;
    },
    updateLocationChecked: (state, action) => {
      state.isLocationCaptured = action.payload;
    },
  },
});

export function useCheckoutStore() {
  const repayMentDataDisb = useSelector(
    (state) => state.checkout.checkoutDataDisb
  );
  const paymentStatusData = useSelector(
    (state) => state.checkout.paymentStatusData
  );
  const paymentDetails = useSelector((state) => state.checkout.paymentDetails);
  const isLocationCaptured = useSelector(
    (state) => state.checkout.isLocationCaptured
  );
  const orderDetailsData = useSelector(
    (state) => state.checkout.orderDetailsData
  );
  const dispatch = useDispatch();
  return {
    repayMentDataDisb,
    paymentStatusData,
    paymentDetails,
    orderDetailsData,
    isLocationCaptured,
    updateRepaymentDataDisb: (payload) =>
      dispatch(updateRepaymentDataDisb(payload)),
    updatePaymentStatusData: (payload) =>
      dispatch(updatePaymentStatusData(payload)),
    updatePaymentDetails: (payload) => dispatch(updatePaymentDetails(payload)),
    updateOrderDetails: (payload) => dispatch(updateOrderDetails(payload)),
    updateLocationChecked: (payload) =>
      dispatch(updateLocationChecked(payload)),
  };
}

export const {
  updateRepaymentDataDisb,
  updatePaymentStatusData,
  updatePaymentDetails,
  updateOrderDetails,
  updateLocationChecked,
} = checkoutSlice.actions;

export default checkoutSlice.reducer;
